import React from "react";
import MarkerClusterGroup from "react-leaflet-markercluster";
import { Marker } from "react-leaflet";
import { setMapDialog, setMapDialogData } from "../../redux/actions/shared-actions";
import { useDispatch, useSelector } from "react-redux";
/**
 * Creates a leaflet marker cluster group to be shown on the Map component.
 * @component
 * @category Components
 * @subcategory Map
 * @param {array | object} data  contains data for the markers
 * @param {function} iconCreater returns the icon for the cluster of markers
 * @param {function} iconGetter returns the icon of the marker
 * @param {object} stopData the stop data needed in case the markers are stops
 */

const MapClusterGroups = ({ data, iconCreater, iconGetter, stopData }) => {
  const { selectedLine } = useSelector((state) => ({
    selectedLine: state.shared.selectedLine,
  }));
  React.useEffect(() => {}, [selectedLine]);

  const dispatch = useDispatch();
  return (
    <MarkerClusterGroup showCoverageOnHover={false} iconCreateFunction={iconCreater}>
      {Array.isArray(data)
        ? data.map((el, index) => {
            return (
              <Marker
                key={el.id ? el.id : el.stationName}
                name={el.id ? el.id : el.stationName}
                position={el.latitude ? [el.latitude, el.longitude] : [el.lat, el.lng]}
                icon={iconGetter()}
                eventHandlers={{
                  click: () => {
                    if (stopData) {
                      dispatch(setMapDialog(true));
                      dispatch(
                        setMapDialogData({
                          type: iconGetter().options.iconUrl.split("/icons/")[1].slice(0, -5),
                          id: index,
                          line: stopData.line,
                          direction: stopData.direction,
                        })
                      );
                    } else {
                      dispatch(setMapDialog(true));
                      dispatch(
                        setMapDialogData({
                          type: iconGetter().options.iconUrl.split("/icons/")[1].slice(0, -5),
                          id: index,
                        })
                      );
                    }
                  },
                }}
              />
            );
          })
        : Object.keys(data).map((id) => {
            //Filtering the avl data by selected line
            if (data[id].vehicleType) {
              if (
                !selectedLine ||
                selectedLine === "ALL_TRAMS" ||
                selectedLine === "ALL_TROLLEYS_AND_EBUSES" ||
                selectedLine === "ALL_BUSES"
              ) {
                return (
                  <Marker
                    key={id}
                    name={id}
                    position={[data[id].latitude, data[id].longitude]}
                    eventHandlers={{
                      click: (e) => {
                        dispatch(setMapDialog(true));
                        dispatch(
                          setMapDialogData({
                            type: iconGetter().options.iconUrl.split("/icons/")[1].slice(0, -5),
                            id: id,
                          })
                        );
                      },
                    }}
                    icon={iconGetter()}
                  />
                );
              } else {
                return data[id].line === selectedLine ? (
                  <Marker
                    key={id}
                    name={id}
                    position={[data[id].latitude, data[id].longitude]}
                    eventHandlers={{
                      click: (e) => {
                        dispatch(setMapDialog(true));
                        dispatch(
                          setMapDialogData({
                            type: iconGetter().options.iconUrl.split("/icons/")[1].slice(0, -5),
                            id: id,
                          })
                        );
                      },
                    }}
                    icon={iconGetter()}
                  />
                ) : null;
              }
              //handling other data types
            } else {
              return (
                <Marker
                  key={id}
                  name={id}
                  position={[data[id].latitude, data[id].longitude]}
                  eventHandlers={{
                    click: () => {
                      dispatch(setMapDialog(true));
                      dispatch(
                        setMapDialogData({
                          type: iconGetter().options.iconUrl.split("/icons/")[1].slice(0, -5),
                          id: id,
                        })
                      );
                    },
                  }}
                  icon={iconGetter()}
                />
              );
            }
          })}
    </MarkerClusterGroup>
  );
};
export default React.memo(MapClusterGroups);
